/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, {
  useEffect, useMemo, useState, useRef
} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useMeasure } from 'react-use';

import ShareToApp from '../ShareToApp'
import ShareQr from '../ShareQr'
import withClientAndShare from '../../hoc/withClientAndShare'

import useOnScreen from '../../hooks/useOnScreen'


const WebShare = ({
  clientClosed,
  clientConfiguration,
  clientHostContext,
  clientActions,
  shareDisplayAsQrCode,
  shareInitialising,
  shareActions,
}) => {
  const { setDimensions: setClientDimensions } = clientActions
  const { initialise: initialiseShare } = shareActions
  const [hasInitialisedOnce, setHasInitialisedOnce] = useState(shareInitialising)

  const readyToStart = useMemo(() => !!clientConfiguration && !!clientHostContext, [clientConfiguration, clientHostContext])

  const [
    refDimensions, {
      width: measuredWidth,
      height: measuredHeight
    }
  ] = useMeasure();

  const refVisibility = useRef()
  const isVisible = useOnScreen({
    ref: refVisibility,
    rootMargin: '-2px',
    useOnce: true
  })

  useEffect(() => {
    if (isVisible) {
      // Note: adding a 1px extra for safety (scrollbar can appear when exact height)
      setClientDimensions({ width: measuredWidth, height: measuredHeight + 1 })
    }
  }, [isVisible, measuredWidth, measuredHeight, setClientDimensions])


  useEffect(() => {
    if (isVisible && !hasInitialisedOnce && readyToStart) {
      setHasInitialisedOnce(true)
      initialiseShare()
    }
  }, [isVisible, hasInitialisedOnce, initialiseShare, readyToStart])


  const webShareClassNames = classNames('webshare', {
    'webshare--fade-out': clientClosed,
    'webshare--fade-in': !clientClosed
  })

  let content = null
  if (readyToStart) {
    content = shareDisplayAsQrCode
      ? <ShareQr />
      : <ShareToApp />
  }

  return (
    <div className={webShareClassNames} ref={refVisibility}>
      <div className="webshare__content-section" ref={refDimensions}>
        {content}
      </div>
    </div>
  )
}

WebShare.defaultProps = {
  clientConfiguration: undefined,
  clientHostContext: undefined,
}

WebShare.propTypes = {
  clientClosed: PropTypes.bool.isRequired,
  clientConfiguration: PropTypes.shape({
    skinId: PropTypes.string
  }),
  clientActions: PropTypes.shape({
    close: PropTypes.func.isRequired
  }).isRequired,
  clientHostContext: PropTypes.shape({
    device: PropTypes.shape({
      type: PropTypes.string
    }).isRequired
  }),
  shareDisplayAsQrCode: PropTypes.bool.isRequired,
  shareInitialising: PropTypes.bool.isRequired,
  shareActions: PropTypes.shape({
    initialise: PropTypes.func.isRequired,
  }).isRequired,

}

export default withClientAndShare(WebShare)
